import { Box, Card, Grid, Stack } from "@mui/material";
import { createContext } from "react";
import { getProfileById } from "../../../api/profile";
import { SomethingWentWrong } from "../../../components/form/errors";
import { useQueryWithDispatch } from "../../../hooks/useQueryWithDispatch";
import BasicDetails from "./basic-details";
import Environment from "./environment";
import AmbassadorIntrestedIn from "./priorities";
import ProductList from "./product-list";
import { ProfileCard } from "./profile-card";
import ProfileCompletion from "./profile-completion";

export const AmbassadorProfileContext = createContext({
  data: null,
  editMode: true,
  loading: false,
  showCompanyName: undefined,
  showIntrestedIn: undefined,
  limitedAccess: false,
  fullProfile: true,
  showInitiativesNote: false,
});

export default function AmbassadorProfile({
  fetchData = true,
  editable,
  data,
  id,
  showCompanyName,
  showIntrestedIn = true,
  limitedAccess = false,
  fullProfile = true,
  showInitiativesNote = false,
}: any) {
  const enabled = Boolean(fetchData && id);

  const {
    data: response,
    isPending: loading,
    isError: hasError,
  } = useQueryWithDispatch({
    queryKey: ["ambassador-profile", id],
    thunkAction: (v: { id: string }) => getProfileById(v.id),
    variables: { id: id ?? "" },
    enabled,
    showErrorToast: true,
  });

  const profileData = enabled
    ? (response?.data ?? null)
    : data;

  if (enabled && hasError) {
    return (
      <Box py={4} display="flex" justifyContent="center">
        <SomethingWentWrong />
      </Box>
    );
  }

  return (
    <AmbassadorProfileContext.Provider
      value={{
        loading,
        data: profileData,
        editMode: editable,
        showCompanyName,
        showIntrestedIn,
        limitedAccess,
        fullProfile,
        showInitiativesNote,
      }}
    >
      {!editable ? (
        <ProfileCard />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={editable ? 4 : 12} xl={editable ? 3 : 12}>
            <Card>
              <Stack gap={1}>
                <BasicDetails />
                {editable && <ProfileCompletion />}
              </Stack>
            </Card>
          </Grid>
          <Grid item xs={12} md={8} xl={9}>
            <Card>
              <Stack gap={4}>
                <Environment />
                {showIntrestedIn && <AmbassadorIntrestedIn />}
                <ProductList />
              </Stack>
            </Card>
          </Grid>
        </Grid>
      )}
    </AmbassadorProfileContext.Provider>
  );
}
